export default "/_next/static/media/nordic design.9587aa1e7c433ca4792780eba1358880.jpg";